export default "/images/ea1125f44fa9a262b9af48cb7ba4cd35.avif";